// @flow
import type {Element} from 'react'
import React, {Component} from 'react'
import {propOr} from 'ramda'

import type {Role, MoveItemsOptionMap, UpdateCallback} from 'components/proposals/types'
import {SelectItems} from '../../ui'

type Props = {
  childSupportedRole: Role,
  isReadonly: boolean,
  onChange: UpdateCallback,
  policiesToMoveDown: MoveItemsOptionMap,
  policiesToMoveUp: MoveItemsOptionMap,
  rolesToMoveDown: MoveItemsOptionMap,
  rolesToMoveUp: MoveItemsOptionMap,
}

class Editor extends Component<Props> {
  get roleName(): string {
    return propOr('', 'localizedName', this.props.childSupportedRole)
  }

  render(): Element<"div"> {
    const {onChange, isReadonly} = this.props
    const name = this.roleName
    const selectorClassName = 'proposal-part-move-items__selector'

    return (
      <div className="proposal-part-move-items">
        <SelectItems
          isReadonly={isReadonly}
          items={this.props.policiesToMoveUp}
          onChange={onChange}
          path={['policiesToMoveUp']}
          title={I18n.t('proposals.circle_absorb_policies.select_policies_out', {childRole: name})}
          className={selectorClassName}
        />
        <SelectItems
          isReadonly={isReadonly}
          items={this.props.rolesToMoveUp}
          onChange={onChange}
          path={['rolesToMoveUp']}
          title={I18n.t('proposals.circle_absorb_roles.select_roles_out', {childRole: name})}
          className={selectorClassName}
        />
        <SelectItems
          isReadonly={isReadonly}
          items={this.props.policiesToMoveDown}
          onChange={onChange}
          path={['policiesToMoveDown']}
          title={I18n.t('proposals.circle_absorb_policies.select_policies_in', {childRole: name})}
          className={selectorClassName}
        />
        <SelectItems
          isReadonly={isReadonly}
          items={this.props.rolesToMoveDown}
          onChange={onChange}
          path={['rolesToMoveDown']}
          title={I18n.t('proposals.circle_absorb_roles.select_roles_in', {childRole: name})}
          className={selectorClassName}
        />
      </div>
    )
  }
}

export default Editor
